import React from 'react';

/** Placeholder while slot links or linked note content is still loading. */
export const EmbeddedNotepadSlotSkeleton = ({ label }) => (
  <div className="rounded-xl border border-gray-200 bg-gray-50 p-4 animate-pulse">
    <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">{label}</p>
    <div className="space-y-2">
      <div className="h-5 w-2/3 rounded bg-gray-200" />
      <div className="h-4 w-full rounded bg-gray-200" />
      <div className="h-4 w-4/5 rounded bg-gray-200" />
    </div>
  </div>
);

export const EmbeddedNotepadPanelSkeleton = ({ slots }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    {slots.map((slot) => (
      <EmbeddedNotepadSlotSkeleton key={slot.key} label={slot.label} />
    ))}
  </div>
);
